/**
 * Prosta funkcja noise dla zniekształceń i losowości
 * Deterministyczna - te same wartości wejściowe dają te same wyniki
 */
export function simpleNoise(x, y) {
    const n = Math.sin(x * 12.9898 + y * 78.233) * 43758.5453;
    return n - Math.floor(n);
}

